import React from 'react';
import './BusinessPrompt.css';

interface BusinessPromptProps {
    isOpen: boolean;
    onClose: () => void;
    whatsappNumber: string;
}

const BusinessPrompt: React.FC<BusinessPromptProps> = ({ isOpen, onClose, whatsappNumber }) => {
    if (!isOpen) return null;

    const handleWhatsAppClick = () => {
        const message = encodeURIComponent('مرحباً، أريد إضافة نشاطي التجاري');
        const formattedNumber = whatsappNumber.startsWith('+') ? whatsappNumber.slice(1) : whatsappNumber;
        window.open(`https://wa.me/${formattedNumber}?text=${message}`, '_blank');
        onClose();
    };

    return (
        <div className="business-prompt-overlay">
            <div className="business-prompt">
                <div className="business-prompt-header">
                    <button className="close-button" onClick={onClose}>×</button>
                </div>
                <div className="business-prompt-content">
                    <div className="business-icon">
                        <svg viewBox="0 0 24 24">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z"/>
                        </svg>
                    </div>
                    <h2>أضف نشاطك التجاري</h2>
                    <div className="business-features">
                        <div className="feature">
                            <h3>قم بترويج نشاطك التجاري</h3>
                            <p>نحن هنا لمساعدتك في تعزيز وجودك الرقمي والوصول إلى عملاء جدد.</p>
                        </div>
                        <div className="feature">
                            <h3>توسع في السوق</h3>
                            <p>هل لديك نشاط تجاري وترغب في التوسع؟ تواصل معنا الآن لزيادة الظهور والتفاعل مع عملائك.</p>
                        </div>
                        <div className="feature">
                            <h3>منصة متكاملة</h3>
                            <p>نقدم لك منصة سهلة وسريعة للإعلان عن نشاطك التجاري وربطك مباشرة مع عملائك.</p>
                        </div>
                    </div>
                    <button className="whatsapp-button" onClick={handleWhatsAppClick}>
                        <svg viewBox="0 0 24 24" className="whatsapp-icon">
                            <path d="M16.75 13.96c.25.13.41.2.46.3.06.11.04.61-.21 1.18-.2.56-1.24 1.1-1.7 1.12-.46.02-.47.36-2.96-.73-2.49-1.09-3.99-3.75-4.11-3.92-.12-.17-.96-1.38-.92-2.61.05-1.22.69-1.8.95-2.04.24-.26.51-.29.68-.26h.47c.15 0 .36-.06.55.45l.69 1.87c.06.13.1.28.01.44l-.27.41-.39.42c-.12.12-.26.25-.12.5.12.26.62 1.09 1.32 1.78.91.88 1.71 1.17 1.95 1.3.24.14.39.12.54-.04l.81-.94c.19-.25.35-.19.58-.11l1.67.88"/>
                        </svg>
                        تواصل معنا عبر واتساب
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BusinessPrompt; 